module.exports = __webpack_public_path__ + "static/media/group-2@2x.36d848b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group-2@2x.png
// module id = 582
// module chunks = 1